import { DrilldownPanelType } from 'types'

/**
 * Enable Impl-specific panels for specific organizations.
 *
 * This is used to enable panels that are not globally available, but are
 * enabled for specific organizations.
 *
 */
export const PANEL_FLAGS_BY_ORG: { [orgId: string]: DrilldownPanelType[] } = {
  'falcon-6f06dc': ['rbiMatrix', 'niiTable'],
  'osprey-41b322': ['rbiMatrix', 'niiTable'],
}
